module.exports = __webpack_public_path__ + "static/media/materialAwesome.9ce4cffb.svg";